import * as angular from 'angular';
import * as _ from 'underscore';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { SalesAssistantListItem, SalesAssistantPagingResult, StoreForShopingListItem } from '../../../core';
import { IRetailerRootScope } from '../../../core/models';
import { ShopService } from '../../../places/shop.service';
import { IStoreForShopingListItem } from '../../../store-managers/models';
import { JispPayService } from '../../jispPay.service';
import { AccountTypeEnum, IPaginationjisppayStaffFilter, ISalesAssistantListItem } from '../../models';
import { IJispPayAccount, IJispPayAccountTypeEnum } from '../../models/IJispPayAccount';
import { IVendorTableItem } from '../vendors/models/IVendorListItem';
import { IVendorSearchFilter } from '../vendors/models/IVendorSearchFilter';
import { VendorsMockService } from '../vendors/vendors-mock.service';

class JispPayStaffController {
    public static $inject = ['$rootScope', '$scope', '$q', 'jispPayService', 'shopService', 'popupService', 'notificationService', '$translate', 'vendorsMockService', '$uibModal'];

    public waiting = false;
    public staff: SalesAssistantPagingResult = null;
    // public vendors: {Items: IVendorTableItem[], Total: number} = null;
    public tableData: ISalesAssistantListItem[] | IVendorTableItem[];
    public tableTotal: number;
    public accountTypes = AccountTypeEnum;
    public defaultAccountType: IJispPayAccount = { name: 'Vendor', type: IJispPayAccountTypeEnum.Vendor };

    public settings = {
        pageSize: 10,
        page: 1,
        places: [] as IStoreForShopingListItem[],
        accountTypes: [{ name: 'Vendor', type: IJispPayAccountTypeEnum.Vendor }, { name: 'Staff', type: IJispPayAccountTypeEnum.Staff }] as IJispPayAccount[],
        isStaffAny: {
            active: null,
            archived: false
        },
        isAllAccountsSelected: false,
        filter: {
            account: this.defaultAccountType,
            place: null,
            keyword: null,
            isActive: true
        },
        isVendorTypeTable: false,
        sort: this.jispPayService.getColumnSort(),
        getStaffFilter: (): IPaginationjisppayStaffFilter => {
            const i = this.settings;
            const placeID = i.filter.place ? i.filter.place.ID : '';
            const keyword = i.filter.keyword ? i.filter.keyword.trim() : '';
            return {
                limit: i.pageSize,
                offset: (i.page - 1) * i.pageSize,
                sortColumn: i.sort.column,
                sortOrder: i.sort.order,
                placeID,
                keyword,
                isActive: i.filter.isActive
            };
        },
        getVendorFilter: (): IVendorSearchFilter => {
            return {
                searchTerm: this.settings.filter.keyword,
                limit: 20,
                archived: !this.settings.filter.isActive,
            };
        },
        setPlaces: (places: IStoreForShopingListItem[]) => {
            const i = this.settings;
            i.places = places.length !== 0 ? angular.copy(places) : [];
            i.places.unshift({
                ID: null,
                Name: this.$translate.instant('all_locations')
            } as IStoreForShopingListItem);
        },
        setTableData: () => {
            this.tableData = this.staff.Items as ISalesAssistantListItem[];
            this.tableTotal = this.staff.Total;
            // this.tableData = this.settings.isVendorTypeTable ?
            //     this.vendors.Items as IVendorTableItem[] :
            //     this.staff.Items as ISalesAssistantListItem[];
            // this.tableTotal = this.settings.isVendorTypeTable ?
            //     this.vendors.Total :
            //     this.staff.Total;
        },
        setCheckboxes: () => {
            const i = this.settings;
            if (this.tableData) {
                const currentAccounts: Array<ISalesAssistantListItem | IVendorTableItem> = this.getCurrentTableData();
                currentAccounts.forEach((account) => account.selected = i.isAllAccountsSelected);
            }
        },
        setTableType: () => {
            this.settings.isVendorTypeTable = this.settings.filter.account.type === this.defaultAccountType.type;
        },
        changeSelected: () => {
            const currentAccounts: Array<ISalesAssistantListItem | IVendorTableItem> = this.getCurrentTableData();
            this.settings.isAllAccountsSelected = currentAccounts.every((account) => account.selected);
        },
        isAccountSelected: () => {
            if (this.tableData) {
                const currentAccounts: Array<ISalesAssistantListItem | IVendorTableItem> = this.getCurrentTableData();
                return currentAccounts.some((account) => account.selected);
            }
            return false;
        },
        showPanel: () => {
            const i = this.settings;
            return (i.filter.isActive && i.isStaffAny.active) || (!i.filter.isActive && i.isStaffAny.archived);
        },
        isPlacesAny: () => {
            return this.placesModel.active && this.placesModel.active.length !== 0;
        },
    };

    private placesModel = {
        all: [] as IStoreForShopingListItem[],
        banned: [] as IStoreForShopingListItem[],
        active: [] as IStoreForShopingListItem[],
        archived: [] as IStoreForShopingListItem[],
        set: (places: IStoreForShopingListItem[]) => {
            const i = this.placesModel;
            i.all = places;
            i.all.forEach((place) => place.info = place.Name + ', ' + place.Town + ', ' + place.Address);
            i.active = places.filter((place) => {
                if (place.IsActive && !place.IsBanned ) {
                    return true;
                }
            });
            i.archived = places.filter((place) => !place.IsActive);
            i.banned = places.filter((place) => place.IsBanned);
        }
    };

    constructor(
        private $rootScope: IRetailerRootScope,
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private jispPayService: JispPayService,
        private shopService: ShopService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService,
        private vendorsService: VendorsMockService,
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {
        this.init();
    }

    public archiveAccount = async (staff: ISalesAssistantListItem) => {
        let selectedStaff = [];
        if (staff) {
            selectedStaff = [staff];
        } else {
            selectedStaff = _.where(this.staff.Items, { selected: true });
        }
        const size = _.size(selectedStaff);
        if (size === 0) {
            return;
        }

        const message = size > 1
            ? `<p>${this.$translate.instant('archive_selected_accounts_confirm')}</p>`
            : `<p>${this.$translate.instant('archive_a_selected_account_confirm')}</p>`;

        const title = size > 1
            ? this.$translate.instant('archive_selected_accounts')
            : this.$translate.instant('archive_a_selected_account');

        let li = '';
        _.forEach(selectedStaff, (staff) => {
            li += `<li>${staff.FirstName} ${staff.LastName} </li>`;
        });
        const ul = `<ul>${li}</ul>`;
        try {
            await this.popupService.confirm({
                title,
                content: message + ul,
                okTxt: this.$translate.instant('no'),
                cancelTxt: this.$translate.instant('yes'),
                cancelClass: 'btn-success',
                invertAction: true
            });
            this.waiting = true;
            this.notificationService.showWaitingMessage();
            const ids = _.pluck(selectedStaff, 'ID');
            await this.jispPayService.archiveStaff(ids);
            this.getStaff();
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    // public archiveAccount = async (account: ISalesAssistantListItem | IVendorTableItem) => {
    //     let selectedAccounts = [];
    //     const currentAccounts: Array<ISalesAssistantListItem | IVendorTableItem> = this.getCurrentTableData();
    //     if (account) {
    //         selectedAccounts = [account];
    //     } else {
    //         selectedAccounts = currentAccounts.filter((accountItem) => accountItem.selected);
    //     }
    //     const size = selectedAccounts.length;
    //     if (size === 0) {
    //         return;
    //     }
    //     const ids = selectedAccounts.map((accountItem) => accountItem.ID);

    //     const message = size > 1 ? 'archive_selected_accounts_confirm' : 'archive_a_selected_account_confirm';

    //     let titleText;
    //     if (size > 1) {
    //         titleText = this.settings.isVendorTypeTable ? 'archive_vendors_title' : 'archive_selected_accounts';
    //     } else {
    //         titleText = this.settings.isVendorTypeTable ? 'archive_vendor_title' : 'archive_a_selected_account';
    //     }

    //     try {
    //         const isArchiveApproved = await this.$uibModal.open({
    //             component: 'archiveConfirmationDialog',
    //             resolve: {
    //                 title: () => titleText,
    //                 message: () => message,
    //                 accounts: () =>  selectedAccounts.map((accountItem) => `${accountItem.FirstName} ${accountItem.LastName}`)
    //             },
    //             size: 'md',
    //             windowClass: 'archiveDialog',
    //             backdrop: 'static'
    //         }).result;

    //         if (isArchiveApproved) {
    //             this.waiting = true;
    //             // const currentArchiveMethod = this.settings.isVendorTypeTable ? null : await this.jispPayService.archiveStaff(ids);
    //             await this.jispPayService.archiveStaff(ids);
    //             this.notificationService.showWaitingMessage();
    //             this.getStaff();
    //         }
    //     } catch (error) {
    //         if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
    //             this.notificationService.showErrorMessage(error);
    //         }
    //     }
    // }

    public restoreAccount = async (account: ISalesAssistantListItem | IVendorTableItem) => {
        let selectedAccounts = [];
        const currentAccounts: Array<ISalesAssistantListItem | IVendorTableItem> = this.getCurrentTableData();
        if (account) {
            selectedAccounts = [account];
        } else {
            selectedAccounts = currentAccounts.filter((accountItem) => accountItem.selected);
        }
        const ids = selectedAccounts.map((accountItem) => accountItem.ID);
        if (ids.length === 0) {
            return;
        }

        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            await this.jispPayService.restoreStaff(ids);
            // const currentRestoreMethod = this.settings.isVendorTypeTable ? null : await this.jispPayService.restoreStaff(ids);
            this.settings.filter.isActive = true;
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    public setAccount = async (type: number, account?: ISalesAssistantListItem | IVendorTableItem) => {
        try {
            const currentEditMethod = await this.jispPayService.openAccountManager(account as ISalesAssistantListItem, this.placesModel.all);
            // const currentEditMethod = type === this.accountTypes.vendor ?
            //     await this.jispPayService.openVendorEditor(this.placesModel.all, account as IVendorTableItem) :
            //     await this.jispPayService.openAccountManager(account as ISalesAssistantListItem, this.placesModel.all);
            if (currentEditMethod) {
                this.getStaff();
            }
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClick(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    public getAvatarUrl(id: number): string {
        return (id)
            ? this.jispPayService.getAvatarUrl(id, 48, 48)
            : '';
    }

    public getCurrentEditedType() {
        return this.accountTypes.staff;
        // this.settings.isVendorTypeTable ? this.accountTypes.vendor : this.accountTypes.staff;
    }

    private setAccountPlaces(account: ISalesAssistantListItem | IVendorTableItem) {
        account.PlacesID.forEach((placeId) => {
            const place = this.placesModel.all.find((placeItem) => placeItem.ID === placeId);
            if (place) {
                account.places.push({
                    id: place.ID,
                    info: place.info,
                    isActive: place.IsActive,
                    isBanned: place.IsBanned
                });
                account.isContainsBanned = place.IsBanned ? place.IsBanned : account.isContainsBanned;
            }
        });
    }

    private getCurrentTableData() {
        return  this.staff.Items as ISalesAssistantListItem[];
            // this.settings.isVendorTypeTable =
            // this.vendors.Items as IVendorTableItem[] :
            // this.staff.Items as ISalesAssistantListItem[];
    }

    private getStaff = async () => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const response = await this.$q.all(
                [this.jispPayService.getStaff(this.settings.getStaffFilter()),
                this.jispPayService.isStaffAny(true),
                this.jispPayService.isStaffAny(false),
                // this.vendorsService.getVendors(this.settings.getVendorFilter())
                ]);
            this.staff = response[0];
            this.settings.isStaffAny.active = response[1];
            this.settings.isStaffAny.archived = response[2];
            // this.vendors = response[3];
            // this.vendors = {
            //     Items: this.data as IVendorTableItem[],
            //     Total: this.data.length
            // };
            this.staff.Items.forEach((account: ISalesAssistantListItem) => {
                account.avatarUrl = this.getAvatarUrl(account.AvatarID);
                account.places = [];
                account.isContainsBanned = false;
                this.setAccountPlaces(account);
            });

            this.settings.setTableData();
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private init = async () => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const places = await this.shopService.getStoresForJispPay() as IStoreForShopingListItem[];
            this.placesModel.set(places);
            this.getStaff();
            this.settings.setPlaces(this.placesModel.active);
            this.$scope.$watchGroup(['vm.settings.sort.column', 'vm.settings.sort.order', 'vm.settings.filter.keyword',
                'vm.settings.filter.place', 'vm.settings.page', 'vm.settings.filter.isActive'], (n: any, o: any) => {
                    this.settings.isAllAccountsSelected = false;
                    this.settings.setCheckboxes();
                    if (n && n !== o) {
                        this.getStaff();
                    }
                });

        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }
}

angular.module('naut').component('jispPayStaff', {
    template: require('./jispPayStaff.html'),
    controller: JispPayStaffController,
    controllerAs: 'vm'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/components/jispPayStaff/jispPayStaff.component.ts